import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';


const BulkActionToolbar = ({ selectedCount, onBulkAction, onClearSelection }) => {
  const [selectedAction, setSelectedAction] = useState('');
  const [isActionMenuOpen, setIsActionMenuOpen] = useState(false);

  const bulkActions = [
    { value: 'cancel', label: 'Cancel Selected Trades', icon: 'X', variant: 'destructive' },
    { value: 'retry', label: 'Retry Failed Trades', icon: 'RefreshCw', variant: 'default' },
    { value: 'export', label: 'Export Selected', icon: 'Download', variant: 'outline' },
    { value: 'archive', label: 'Archive Trades', icon: 'Archive', variant: 'secondary' }
  ];

  const handleBulkAction = (action) => {
    if (action && selectedCount > 0) {
      onBulkAction(action);
      setSelectedAction('');
      setIsActionMenuOpen(false);
    }
  };

  const getActionButton = (action) => {
    const actionConfig = bulkActions?.find(a => a?.value === action);
    if (!actionConfig) return null;

    return (
      <Button
        variant={actionConfig?.variant}
        size="sm"
        onClick={() => handleBulkAction(action)}
        iconName={actionConfig?.icon}
        iconPosition="left"
        iconSize={16}
      >
        {actionConfig?.label}
      </Button>
    );
  };

  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50">
      <div className="bg-card border border-border rounded-lg shadow-elevated px-6 py-4 min-w-96">
        <div className="flex items-center justify-between space-x-4">
          {/* Selection Info */}
          <div className="flex items-center space-x-3">
            <div className="flex items-center space-x-2">
              <Icon name="CheckSquare" size={20} className="text-primary" />
              <span className="text-sm font-medium text-foreground">
                {selectedCount} trade{selectedCount !== 1 ? 's' : ''} selected
              </span>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex items-center space-x-2">
            {/* Quick Actions */}
            <div className="flex items-center space-x-2">
              <Button
                variant="outline"
                size="sm"
                onClick={() => handleBulkAction('export')}
                iconName="Download"
                iconPosition="left"
                iconSize={16}
              >
                Export
              </Button>

              <Button
                variant="destructive"
                size="sm"
                onClick={() => handleBulkAction('cancel')}
                iconName="X"
                iconPosition="left"
                iconSize={16}
              >
                Cancel
              </Button>
            </div>

            {/* More Actions Dropdown */}
            <div className="relative">
              <Button
                variant="ghost"
                size="sm"
                onClick={() => setIsActionMenuOpen(!isActionMenuOpen)}
                iconName="MoreVertical"
                iconSize={16}
                className="text-muted-foreground hover:text-foreground"
              />

              {isActionMenuOpen && (
                <div className="absolute bottom-full right-0 mb-2 w-48 bg-popover border border-border rounded-md shadow-elevated z-50">
                  <div className="py-2">
                    {bulkActions?.map((action) => (
                      <button
                        key={action?.value}
                        onClick={() => handleBulkAction(action?.value)}
                        className="w-full flex items-center space-x-3 px-4 py-2 text-sm text-popover-foreground hover:bg-muted transition-smooth"
                      >
                        <Icon name={action?.icon} size={16} />
                        <span>{action?.label}</span>
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* Clear Selection */}
            <Button
              variant="ghost"
              size="sm"
              onClick={onClearSelection}
              iconName="X"
              iconSize={16}
              className="text-muted-foreground hover:text-foreground"
            />
          </div>
        </div>

        {/* Progress Indicator for Bulk Actions */}
        <div className="mt-3 pt-3 border-t border-border">
          <div className="flex items-center justify-between text-xs text-muted-foreground">
            <span>Ready to process {selectedCount} trades</span>
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-success rounded-full animate-pulse-subtle"></div>
              <span>System ready</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkActionToolbar;